import moment from "moment";
import { GraphRequest } from "../Utils/GraphRequest";
import { MIAPACons } from "../Utils/MipaConstant";

function savecomment(commentParams: any) {
    let conversationid=commentParams.props.ThreadId;
    if (commentParams.commenttext.length > 0) {

        // define email object
        let email = {
            emailAddress: {
                name: commentParams.props.CurrentUser.displayName,
                address: commentParams.props.CurrentUser.mail
            }
        };

        // check if first time comment
        if (commentParams.props.ThreadId == null) {

            let postJSON = {
                "topic": commentParams.props.data.title,
                "threads": [{
                    "posts": [{
                        "body": {
                            "contentType": "html",
                            "content": commentParams.commenttext
                        },
                        "newParticipants": [email]
                    }]
                }]
            };

            // define api params
            let detailapi = `${MIAPACons.GraphAPI.GraphBaseURL}${MIAPACons.GraphAPI.GroupConversation.replace('{0}', commentParams.props.data.groupId)}`;
            GraphRequest
                .POST(
                    detailapi,
                    commentParams.props.Header,
                    postJSON,
                    (detail: { data: { id: any; }; }) => {
                        conversationid=detail.data.id ;
                        let conobj = { "conversationThreadId": detail.data.id };
                        detailapi = `${MIAPACons.GraphAPI.GraphBaseURL}${MIAPACons.GraphAPI.PlannerTask.replace('{0}', commentParams.props.data.id)}`;

                        GraphRequest.Patch(
                            detailapi,
                            commentParams.props.Header,
                            conobj,
                            (successres: any) => {
                                commentParams.detailSuccesscallback(conversationid);
                                if (commentParams.props.ReloadPlannerTasks && commentParams.props.ThreadId == null)
                                    {
                                        //commentParams.props.ReloadPlannerTasks(true);
                                        //commentParams.props.ReloadPlannerTasks(commentParams.props.data.col);
                                        commentParams.props.ReloadPlannerTasks(95);
                                    }
                            },
                            (failres: any) => {
                                commentParams.detailErrorcallback(failres);
                            },
                            commentParams.props.Progress,
                            commentParams.props.data['@odata.etag']);

                    },
                    (error: any) => {
                        commentParams.errorcallback(error);
                    },
                    commentParams.props.Progress);

        }
        else {
            var obj = {
                post: {
                    body: { content: commentParams.commenttext, contentType: "html" },
                    from: email,
                    lastModifiedDateTime: moment().format()
                }
            }
            let taskcomment = `${MIAPACons.GraphAPI.GraphBaseURL}${MIAPACons.GraphAPI.GroupReply.replace('{0}', commentParams.props.data.groupId).replace('{1}', commentParams.props.ThreadId)}`;
            GraphRequest
                .POST(taskcomment,
                    commentParams.props.Header,
                    obj,
                    (sucres: any) => {
                        commentParams.successcallback(conversationid);
                        if (commentParams.props.ReloadPlannerTasks && commentParams.props.ThreadId == null)
                            commentParams.props.ReloadPlannerTasks(commentParams.props.data.col);
                    },
                    (errres: any) => {
                        commentParams.errorcallback(errres);
                    },
                    commentParams.props.Progress);
        }

        // if (commentParams.props.ReloadPlannerTasks && commentParams.props.ThreadId == null)
        //     commentParams.props.ReloadPlannerTasks(commentParams.props.data.col);

       
    }
};



const TaskCommentService = {
    savecomment: savecomment
};

// export the service object
export default TaskCommentService;